import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/dua-lecturer/'

export const MyCourses = createAsyncThunk('lecture-courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}my-courses`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyStudents = createAsyncThunk('lecture-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}my-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerProfile = createAsyncThunk('lecture-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerAccountDetails = createAsyncThunk(
  'lecturer-account-details',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}account-details`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditProfile = createAsyncThunk('profile-edit', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}profile-edit`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpdateProfile = createAsyncThunk('profile-update', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}profile-update`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const excelEmptyAtt = createAsyncThunk('std-att-excel', async (formData: FormData) => {
  const response = await axios.post(`${api}get-att-empty-excel-file`, formData, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'AttendanceSheet.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const ImportExcelAttendances = createAsyncThunk(
  'import-student-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}import-attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerNews = createAsyncThunk('lecture-news', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}my-news`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SyllabusDetails = createAsyncThunk(
  'syllabus-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}edit-course-syllabus/${id}`)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const SyllabusStore = createAsyncThunk('syllabus-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}store-syllabus`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MaterialStore = createAsyncThunk('material-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}store-material`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Materials = createAsyncThunk('materials', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}course-materials/${id}`)
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
  }
})

export const DestroyMaterial = createAsyncThunk(
  'destroy-material',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}delete-material/${id}`)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const editMaterial = createAsyncThunk('material-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}material-edit/${id}`)
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
  }
})

type lecturerPortalState = {
  errors: any
}

const initialState: lecturerPortalState = {
  errors: '',
}

export const lecturerPortalSlice = createSlice({
  name: 'lecturer-portal',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = lecturerPortalSlice.actions
export default lecturerPortalSlice.reducer
